import axios from "axios";

const axiosInstance = axios.create({
    baseURL: "https://youtube-mini-server.herokuapp.com",
});

export default axiosInstance;
